import { useEffect, useState } from 'react';
import { FaInstagram } from "react-icons/fa";
import { Link } from 'react-router-dom';

import './Toolbar.css';

const Toolbar = (props) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    onScroll(); // set initial state on mount
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section className={`toolbar ${isScrolled ? 'background-white' : 'background-transparent'}`}>
      <nav className="toolbar_nav" id="toolbar_nav">
        <div className="logo_wrapper">
          <Link to="/"><div className="logo"></div></Link>
        </div>
        <div className="spacer" />
        <div>
          <ul className="toolbar_nav_right">
            <li className="socialIcons"><a href="https://www.instagram.com/brittanysgotcake?igsh=aDllMWQyZzl3eG4x" target="_blank" rel="noopener noreferrer" title="Instagram Account"><FaInstagram /></a></li>
          </ul>
        </div>
      </nav>
    </section>
  );
};

export default Toolbar;